import { render, staticRenderFns } from "./SmartClassifierActionsButton.vue?vue&type=template&id=22cdbe04&scoped=true&"
import script from "./SmartClassifierActionsButton.vue?vue&type=script&lang=js&"
export * from "./SmartClassifierActionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cdbe04",
  null
  
)

export default component.exports